export const LIVE = {
    date: "2025-07-20",
    theme: "结出智慧的果实",
    chapter: "箴言8：12-21",
    speaker: "孙柯楠 牧师",
    youtubeVideoCode: "0B8oyVouw3I"
}
